import { useNavigate } from 'react-router-dom'

import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFrown } from '@fortawesome/free-solid-svg-icons'

const Custom404 = () => {
	const navigate = useNavigate()

	return (
		<Container style={{ textAlign: 'center', margin: '3rem auto' }}>
			<FontAwesomeIcon icon={faFrown} className='fa-10x' color='lightgray' />
			<br /><br /><br />
			<h1 style={{ fontWeight: 700 }}>404</h1>
			<h4 style={{ color: 'darkgray' }}>Page not found</h4>

			<p style={{ fontSize: '14px' }}>The page you&apos;re looking for doesn&apos;t exist</p>
			<Button
				onClick={() => navigate(-1)} style={{ color: 'white', fontWeight: 'bold' }}
			>Click here to go back</Button>
		</Container>
	)
}



export default Custom404
